import { render } from "./CategoryClient.vue?vue&type=template&id=2ebe120b"
import script from "./CategoryClient.vue?vue&type=script&lang=js"
export * from "./CategoryClient.vue?vue&type=script&lang=js"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__